module.exports = __webpack_public_path__ + "static/uxo_wheel_light-111537a60823ed15ff8a1943b91a73ee.mp4";